var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotallySecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1998 16.7428C23.6199 16.7428 23.1498 17.2129 23.1498 17.7928V22.9117H33.8498V17.7928C33.8498 17.2129 33.3797 16.7428 32.7998 16.7428H24.1998ZM35.7498 22.9117V17.7928C35.7498 16.1635 34.429 14.8428 32.7998 14.8428H24.1998C22.5706 14.8428 21.2498 16.1635 21.2498 17.7928V22.9117H17.9998C16.3706 22.9117 15.0498 24.2325 15.0498 25.8617V37.9997C15.0498 39.6289 16.3706 40.9497 17.9998 40.9497H38.9998C40.629 40.9497 41.9498 39.6289 41.9498 37.9997V25.8617C41.9498 24.2325 40.629 22.9117 38.9998 22.9117H35.7498ZM17.9998 24.8117C17.4199 24.8117 16.9498 25.2818 16.9498 25.8617V37.9997C16.9498 38.5796 17.4199 39.0497 17.9998 39.0497H38.9998C39.5797 39.0497 40.0498 38.5796 40.0498 37.9997V25.8617C40.0498 25.2818 39.5797 24.8117 38.9998 24.8117H17.9998Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3504 29.9553C26.9966 30.4271 26.7496 31.1224 26.7496 31.9309C26.7496 32.7393 26.9966 33.4346 27.3504 33.9064C27.7041 34.378 28.1201 34.5809 28.4996 34.5809C28.8791 34.5809 29.2952 34.378 29.6488 33.9064C30.0027 33.4346 30.2496 32.7393 30.2496 31.9309C30.2496 31.1224 30.0027 30.4271 29.6488 29.9553C29.2952 29.4838 28.8791 29.2809 28.4996 29.2809C28.1201 29.2809 27.7041 29.4838 27.3504 29.9553ZM25.8304 28.8153C26.454 27.9838 27.388 27.3809 28.4996 27.3809C29.6113 27.3809 30.5452 27.9838 31.1688 28.8153C31.7921 29.6464 32.1496 30.7511 32.1496 31.9309C32.1496 33.1106 31.7921 34.2153 31.1688 35.0464C30.5452 35.8779 29.6113 36.4809 28.4996 36.4809C27.388 36.4809 26.454 35.8779 25.8304 35.0464C25.2071 34.2153 24.8496 33.1106 24.8496 31.9309C24.8496 30.7511 25.2071 29.6464 25.8304 28.8153Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotallySecure);
export default __webpack_public_path__ + "static/media/totally-secure.7e9b4131.svg";
export { ForwardRef as ReactComponent };